import { useMutation, useQueryClient } from '@tanstack/react-query';
import { jobPositionService } from '../services/jobPosition.service';
import { JobPositionId } from '@/shared/types/branded.types';

interface UseDeleteJobPositionReturn {
  deleteJobPosition: (
    id: string,
    options?: { onSuccess?: () => void; onError?: () => void }
  ) => void;
  deleteJobPositionAsync: (id: string) => Promise<void>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
}

export function useDeleteJobPosition(): UseDeleteJobPositionReturn {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (id: string) => jobPositionService.remove(JobPositionId(id)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['job-positions'] });
    },
  });

  return {
    deleteJobPosition: mutation.mutate,
    deleteJobPositionAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
